import { Button } from "antd";
import "./OnlineMenus.scss";
import { ScissorOutlined } from "@ant-design/icons";
import { useRecoilValue } from "recoil";
import { memberState } from "../../state/atoms";

export default function OnlineMenus() {
  const member = useRecoilValue(memberState);

  function goPro() {
    window.MHM.ProModal.upgrade({memberId: member.id, onSuccess: () => window.location.href = '/'});
  } 

  return <div className={"online-menus page"}>
    <section className="freemium-splash">
      <div className="upgrade-txt">
        <img src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star" />
        <h4>Upgrade to use this feature</h4>
      </div>
      <h2 className="mobile-only">Online Menus</h2>
      <div className="info">
        <div className="text">
          <h2 className="desktop-only">Online Menus</h2>
          <ul>
            <li>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/StockGain.svg" alt="stock gain"/>
              </div>
              <div>
                <h4>Increase in-store sales</h4>
                <p>Turn your tables quicker with a menu that can be viewed in seconds.</p>
              </div>
            </li>
            <li>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/Online.svg" alt="online"/>
              </div>
              <div>
                <h4>Increase online sales</h4>
                <p>Boost takeout sales and avoid commissions with online ordering.</p>
              </div>
            </li>
            <li>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/Smile.svg" alt="online"/>
              </div>
              <div>
                <h4>Better guest experience</h4>
                <p>Delight your customers with a more visual menu optimized for phones.</p>
              </div>
            </li>
            <li>
              <div>
                <ScissorOutlined/>
              </div>
              <div>
                <h4>Cut costs</h4>
                <p>Make fewer table trips and update menus instantly.</p>
              </div>
            </li>
          </ul>
          <Button size={"large"} className={"primary"} onClick={goPro}>
            Get Pro to use Online Menus!
          </Button>
        </div>
        <div className="img">
          <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OMFreemiumSplashHero.webp" alt="lp freemium hero" />
        </div>
      </div>
    </section>
  </div>;
}
